import React from 'react';
import NewBubble from '@/v3/components/Bubble';

/**
 * ConditionalBubble - A wrapper component that renders the new Bubble
 * 
 * @param {Object} props - All props to be passed to the underlying Bubble component
 * @param {Object} props.config - Bubble configuration object
 */
const ConditionalBubble = ({ config, ...otherProps }) => {
  return (
    <NewBubble
      config={config}
      {...otherProps}
    />
  );
};

export default ConditionalBubble;

